
//@ts-nocheck
export default {
  // @ts-ignore
  setProduct(state, payload) {
    state.product = payload
    state.estimate = payload.estimate
  },
  // @ts-ignore
  setEstimate(state, payload) {
    state.estimate = payload
  },
  // @ts-ignore
  setIs3DModalOpen(state, payload) {
    state.is3DModalOpen = payload
  },
  // @ts-ignore
  setImageLoading(state, payload) {
    state.imageLoading = payload
  },
  // @ts-ignore
  setQuantity(state, payload) {
    state.estimate.quantity = payload
  },
  // @ts-ignore
  setFirstOptions(state, payload) {
    state.product.first_options = payload
  },
  // @ts-ignore
  setSecondOptions(state, payload) {
    state.product.second_options = payload
  },
  // @ts-ignore
  setDeliveryOptions(state, payload) {
    state.delivery_options = payload
  },
  setPrintingCapacity(state, payload) {
    state.estimate.print_capacity_per_day.remaining_quantity = payload
  },
  // @ts-ignore
  setSelectedId(state, { content, id }) {
    state.estimate[content].id = id
  },
  // @ts-ignore
  setSelectedTrial(state, payload) {
    state.estimate.trial = payload
  },
  // @ts-ignore
  setSelectedEditPatternId(state, payload) {
    state.estimate.selected_edit_pattern.id = payload
  },
  // @ts-ignore
  setAddToEstimate(state, payload) {
    state.product.added_to_estimate = payload
  },
  // @ts-ignore
  setFavoritesCount(state, payload) {
    state.favoritesCount = payload
  },
  // @ts-ignore
  setEstimateItemId(state, payload) {
    state.product.estimate_item_id = payload
  },
  // @ts-ignore
  setRequestError(state, { actionName, payload }) {
    state.requestError[actionName] = payload
  },
  // @ts-ignore
  setValidQuantity(state, payload) {
    state.validQuantity = payload
  },
  // @ts-ignore
  setIsHandledProduct(state, payload) {
    state.isHandledProduct = payload
  },
  // @ts-ignore
  setPriceTable(state, payload) {
    state.priceTable = payload
  },
  // @ts-ignore
  setIsOrderPlainProduct(state, payload: boolean) {
    state.isOrderPlainProduct = payload
  },
  setServerError(state, payload: {code: string, message: string}) {
    state.serverError = payload
  },
  setUpdatingQuantityInput(state, payload: boolean) {
    state.updatingQuantityInput = payload
  },
  setProductLoading(state, payload: boolean) {
    state.productLoading = payload
  },
  setCurrentSKUImageView(state, payload) {
    state.currentSKUImageView = payload
  },
  setValidLatestQuantityInputValue(state, payload: boolean) {
    state.validLatestQuantityInputValue = payload
  }
}
